import {h, Fragment} from "preact"
import { useState, useEffect } from "preact/hooks"
import { useAppState } from '@nosto/preact'

export default () => {
    const { query, response } = useAppState();
    const [ fullArticlesBlogs, setFullArticlesBlogs ] = useState([]);
    const [ resultArticlesBlogs, setResultArticlesBlogs ] = useState([]);
    const [ dropdownArticlesBlogs, setDropdownArticlesBlogs ] = useState([]);
    const fillerWords = ['the', 'a', 'an', 'of', 'in', 'on', 'at', 'by', 'to', 'for', 'and', 'or', 'but', 'nor', 'with', 'you', 'your', 'we', '&'];

    useEffect(() => {
        if(fullArticlesBlogs?.length > 0) return;
        fetch('https://thehempdivision.com/sitemap_blogs_1.xml')
            .then(res => {
                if(res.ok) {
                    return res.text();
                } else {
                    throw new Error('Error fetching articles and blogs.')
                }
            })
            .then(xml => {
                const parser = new DOMParser();
                const urls = parser.parseFromString(xml, 'text/xml').getElementsByTagName('url');
                let urlList = [];

                for (let i = 0; i < urls.length; i++) {
                    const url = urls[i]; 
                    urlList.push({
                        url: url.querySelector('loc')?.textContent,
                        lastmod: url.querySelector('lastmod')?.textContent,
                        changefreq: url.querySelector('changefreq')?.textContent,
                        imageUrl: url?.querySelector('image loc')?.textContent,
                        title: url?.querySelector('image title')?.textContent,
                    })
                }
                setFullArticlesBlogs(urlList);
            })
            .catch(err => console.error(err))
    }, [fullArticlesBlogs]);
    
    useEffect(() => {
        // search result articles
        if(!query?.query) return
        let filteredUrls = [];
        const keywords = [query.query.toLowerCase()];

        // let keywords = [];
        // (pageType === 'category')
        //     ?   keywords = response?.products?.categoryPath.split(' ')
        //     :   keywords = query?.query.split(' ')
        
        // keywords = keywords
        //     .filter(word => !fillerWords.includes(word.toLowerCase()) && word.trim() !== '')
        //     .map(word => word.toLowerCase());
        filteredUrls = fullArticlesBlogs.filter(url => keywords.some(word => url.title?.toLowerCase()?.includes(word)));
                
        setResultArticlesBlogs(filteredUrls);
    }, [fullArticlesBlogs, query?.query, response?.products?.categoryPath])

    useEffect(() => {
        // autocomplete articles
        if(!response?.query || response?.query.trim() === '') return
        let filteredUrls = [];
        const keywords = response?.query.split(' ')
            .filter(word => !fillerWords.includes(word.toLowerCase()) && word.trim() !== '')
            .map(word => word.toLowerCase());
        filteredUrls = fullArticlesBlogs.filter(url => keywords.some(word => url.title?.toLowerCase()?.includes(word)));        
        setDropdownArticlesBlogs(filteredUrls);
    }, [response?.query])

    return {
        resultArticlesBlogs,
        dropdownArticlesBlogs
    }
}